var React = require('react');

function RightGreen (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#74B076","fillRule":"evenodd","d":"M1409.547,1177.56946 C1436.92035,1173.97732 1456.17957,1148.87231 1452.56376,1121.49583 C1448.94795,1094.11935 1423.82622,1074.8384 1396.453,1078.43054 C1369.07965,1082.02268 1349.82043,1107.12783 1353.43624,1134.50417 C1357.05205,1161.88065 1382.17364,1181.1616 1409.547,1177.56946","transform":"translate(-1353 -1078)"}));
}

RightGreen.defaultProps = {"width":"87","height":"100","viewBox":"0 0 87 100"};

module.exports = RightGreen;

RightGreen.default = RightGreen;
